import React from 'react';
import cx from 'classnames';

import { useTabNavigatorMatch } from './useTabNavigatorMatch';

export function TabHiddenContent(props) {
  const { className, children, show = true, hide = false, index } = props;

  const match = useTabNavigatorMatch(index);

  /*
    Initially checking the priority flags
    After checking the index matching
  */
  const hidden = show === false || hide === true || !match;

  const containerClassName = cx('tab-content', className, { hidden });

  // Extra
  const style = React.useMemo(() => {
    if (hidden) {
      return { display: 'none' };
    }

    return null;
  }, [hidden]);

  return (
    <div className={containerClassName} style={style}>
      {children}
    </div>
  );
}
